import React, { useState, useEffect } from "react";
import { Collapse, List, ListItem, ListItemIcon, ListItemText, ListItemButton, Typography, useTheme } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { useNavigate, useLocation } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";

const SidebarItemCollapse = ({ item }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    const regex = new RegExp(`${path.replace(/:\w+/g, '[^/]+')}`);
    return regex.test(location.pathname);
  };

  useEffect(() => {
    if (item.children.some(child => isActive(child.path))) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [location.pathname, item.children]);

  const handleClick = () => {
    setOpen(!open);
  };


  const CornerIcon = () => (
    <svg
      width="24"
      height="50" // Y-axis is three times taller than X-axis (24 * 3 = 50)
      viewBox="0 0 24 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    // style={{ transform: "rotate(60deg)" }}
    >
      <path d="M0 0 L0 50 L24 50" fill="none" stroke="#FFFFFF" />
    </svg>
  );


  return (
    <>
      <ListItem
        onClick={handleClick}
        sx={{
          cursor: 'pointer',
          pl: 3,
          zIndex: 100,
          color: item.children.some(child => isActive(child.path)) ? theme.palette.primary.sidebar : theme.palette.basic.white, borderRadius: '30px 0 0 30px',
          "&:hover": { backgroundColor: theme.palette.basic.white, color: theme.palette.primary.sidebar },
          backgroundColor: item.children.some(child => isActive(child.path)) ? theme.palette.basic.white : theme.palette.primary.sidebar,
        }}
      >
        <ListItemIcon sx={{ color: item.children.some(child => isActive(child.path)) ? theme.palette.primary.sidebar : "inherit" }}>{item.sidebarProps.icon}</ListItemIcon>
        <ListItemText
          primary={
            <Typography sx={{ fontWeight: 'bold' }}>
              {item.sidebarProps.displayText}
            </Typography>
          }
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {item.children.map((child, index) => {
            return child.sidebarProps?.displayText ?
              <ListItemButton
                key={index}
                sx={{
                  p: 0,
                  pl: 8,
                  position: 'relative',
                }}
                onClick={() => navigate(child.path)}
              >
                <ListItemIcon sx={{
                  minWidth: "auto", marginRight: "16px",
                  position: 'absolute',
                  top: -25,
                  left: 30

                }}>
                  <CornerIcon />
                </ListItemIcon>
                <ListItemText sx={{
                  p: 1,
                  fontWeight: 600,
                  fontFamily: 'poppins',
                  borderRadius: "10px 0 0 10px",
                  color: isActive(child.path) ? theme.palette.primary.sidebar : theme.palette.basic.white,
                  backgroundColor: isActive(child.path) ? theme.palette.secondary.babyBlue : "inherit",
                }} primary={child.sidebarProps?.displayText} />
                {isActive(child?.path) ?
                  <IoIosArrowForward
                    style={{
                      position: 'absolute',
                      top: 15,
                      right: 15,
                      color: isActive(child.path) ? theme.palette.primary.sidebar : theme.palette.basic.white,
                    }}
                  /> : ''}
              </ListItemButton> : ''
          })}
        </List>
      </Collapse>
    </>
  );
};

export default SidebarItemCollapse;
